/**
 * ESB Tiers Gallery JavaScript
 * Handles tab switching for the ESB tiers feature gallery
 */

(function($) {
    'use strict';
    
    $(document).ready(function() {
        
        // Tab switching functionality
        $('.esb-tiers-gallery__tab').on('click', function() {
            const $tab = $(this);
            const targetTier = $tab.data('tier');
            
            // Update active tab
            $('.esb-tiers-gallery__tab').removeClass('active');
            $tab.addClass('active');
            
            // Update active panel with fade effect
            $('.esb-tiers-gallery__panel').removeClass('active');
            $('.esb-tiers-gallery__panel[data-tier="' + targetTier + '"]').addClass('active');
        });
        
    });
    
})(jQuery);
